export const scheduleState = {
    isLoadingFinished: false,
};
export const scheduleGetters = {};
export const scheduleMutations = {};
